function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import classNames from "classnames";
import * as Yup from "yup";
import moment from "moment-timezone";
import React from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form as FormikForm, Formik } from "formik";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import FormGroup from "react-bootstrap/FormGroup";
import { toast } from "react-toastify";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { Chart } from "react-google-charts";
import { FilterContext, UserContext, SearchContext } from "../index";
import { randomColor, getBWColor, convertSecToHours, colors, convertSecToHoursAndMinutesWithTextShortForm } from "../utils";
import Modal from "react-bootstrap/Modal";
import { MY_PROJECTS_QUERY } from "./../MyProjects/query";
import "./ProjectDetails.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { UPDATE_PROJECT_START_DATE_MUTATION, PROJECT_EMPLOYEE_WISE_EARNING_QUERY, TASK_WISE_COST_ANALYSIS_QUERY, GET_TASK_TRACKER_QUERY, PROJECT_BUDGET_DETAILS_SUMMARY_QUERY, PROJECT_PRIORITY_DETAILS_SUMMARY_QUERY, PROJECT_PERSON_WISE_TASK_STATUS_QUERY, PROJECT_EMPLOYEE_WISE_EARNING_EXPORT_QUERY, TASK_WISE_COST_ANALYSIS_EXPORT_QUERY, GET_EXPORT_TASK_TRACKER_QUERY, PROJECT_DETAILS_SUMMARY_QUERY, UPDATE_PROJECT_END_DATE_MUTATION, PROJECT_USER_WISE_TASK_LISTING_QUERY, TASK_WISE_USER_LISTING_QUERY, TASK_WISE_USER_LISTING_EXPORT_QUERY, PROJECT_USER_WISE_TASK_LISTING_EXPORT_QUERY } from "./query.js";
import SearchBar from "../SearchBar";
import Dropdown from "react-bootstrap/Dropdown";
import Loader from "./../Loader/Loader";
import { arrayToStringOutput } from "./../SideMenu/Header";
import { MdEventAvailable, MdAccessTime, MdTrendingUp, MdFormatListBulleted, MdCheck } from "react-icons/md";
import { PROJECTS_LISTING_QUERY, PROJECTS_LISTING_FOR_FILTER_QUERY } from "./../ManualPages/query";
import { VscLoading } from "react-icons/vsc";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { FiDownload, FiMoreHorizontal, FiCheckSquare, FiUsers, FiTarget, FiCalendar, FiEdit, FiSettings, FiPaperclip, FiDollarSign, FiUser, FiFileText } from "react-icons/fi";
import ProgressBar from "react-bootstrap/ProgressBar";
import { RiDeleteBinLine, RiTimerLine, RiFileChartLine } from "react-icons/ri";
import { TimeFilter } from "./DateFilter";
var LIMIT = 25;
var TASK_LIMIT = 25;
var EMPLOYEE_LIMIT = 10;
var TASK_EMP_LIMIT = 10;
var TASK_EMP_OFFSETS = 0;
export var Budget = function Budget(props) {
  var _budgetDetailsData$bu, _budgetDetailsData$bu2, _budgetDetailsData$bu3, _budgetDetailsData$bu4, _budgetDetailsData$bu5, _budgetDetailsData$bu6, _budgetDetailsData$bu7, _budgetDetailsData$bu8, _budgetDetailsData$bu9, _budgetDetailsData$bu10, _budgetDetailsData$bu11, _budgetDetailsData$bu12, _budgetDetailsData$bu13, _budgetDetailsData$bu14, _budgetDetailsData$bu15, _summaryData$projectU, _summaryData$projectU2, _projectListing$proje;
  var role = props.role,
    organisationId = props.organisationId,
    teamId = props.teamId,
    user = props.user,
    projectId = props.projectId,
    timezone = props.timezone,
    budget = props.budget,
    currenciesData = props.currenciesData,
    totalWorkedSec = props.totalWorkedSec,
    summaryData = props.summaryData,
    projectStartDate = props.projectStartDate,
    projectDeadline = props.projectDeadline,
    activeTab = props.activeTab,
    location = props.location,
    organisationBilling = props.organisationBilling,
    organisationSettings = props.organisationSettings,
    projectName = props.projectName,
    startDates = props.startDates,
    endDates = props.endDates;
  var shouldFetch = activeTab === "budget"; // or from parent prop

  var _React$useState = React.useState({
      startDate: new Date(),
      endDate: null
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dates = _React$useState2[0],
    setDate = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    projectDetailFetchs = _React$useState4[0],
    setProjectDetailFetchs = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isNavClick = _React$useState6[0],
    setNavClick = _React$useState6[1];
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _React$useState7 = React.useState(arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    filterData = _React$useState8[0],
    setFilterData = _React$useState8[1];
  var _React$useState9 = React.useState([]),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    userActive = _React$useState10[0],
    setUserActive = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    taskActive = _React$useState12[0],
    setTaskActive = _React$useState12[1];
  var _React$useState13 = React.useState([projectId]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    projectActive = _React$useState14[0],
    setProjectActive = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    exportButton = _React$useState16[0],
    setExportButton = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    exportTaskButton = _React$useState18[0],
    setExportTaskButton = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    exportLogButton = _React$useState20[0],
    setExportLogButton = _React$useState20[1];

  //add start date here
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isStartDateHover = _React$useState22[0],
    setStartDateHover = _React$useState22[1];
  var _React$useState23 = React.useState(projectStartDate !== null && projectStartDate !== void 0 ? projectStartDate : null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    manualDate = _React$useState24[0],
    setManualDate = _React$useState24[1];
  var _React$useState25 = React.useState(null),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isEndDateHover = _React$useState26[0],
    setEndDateHover = _React$useState26[1];
  var _React$useState27 = React.useState(projectDeadline !== null && projectDeadline !== void 0 ? projectDeadline : null),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    manualEndDate = _React$useState28[0],
    setManualEndDate = _React$useState28[1];
  var _React$useState29 = React.useState(""),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    dateError = _React$useState30[0],
    setDateError = _React$useState30[1];
  var _useQuery = useQuery(PROJECT_EMPLOYEE_WISE_EARNING_QUERY, {
      variables: {
        projectId: projectId,
        organisationId: organisationId,
        limit: EMPLOYEE_LIMIT,
        offset: 0
      },
      skip: !shouldFetch || !projectId || !organisationId
    }),
    employeeWiseEarningData = _useQuery.data,
    employeeWiseEarningError = _useQuery.error,
    employeeWiseEarningLoading = _useQuery.loading,
    employeeWiseEarningFetchMore = _useQuery.fetchMore;
  var _useQuery2 = useQuery(PROJECT_BUDGET_DETAILS_SUMMARY_QUERY, {
      variables: {
        projectId: projectId,
        organisationId: organisationId
      },
      skip: !shouldFetch || !projectId || !organisationId
    }),
    budgetDetailsData = _useQuery2.data,
    budgetDetailsError = _useQuery2.error,
    budgetDetailsLoading = _useQuery2.loading;
  var _useQuery3 = useQuery(TASK_WISE_COST_ANALYSIS_QUERY, {
      variables: {
        projectId: projectId,
        organisationId: organisationId,
        limit: EMPLOYEE_LIMIT,
        offset: 0
      },
      // fetchPolicy: "network-only",
      skip: !shouldFetch || !organisationId || !projectId
    }),
    taskData = _useQuery3.data,
    taskError = _useQuery3.error,
    taskLoading = _useQuery3.loading,
    taskFetchMore = _useQuery3.fetchMore;
  var _useQuery4 = useQuery(PROJECTS_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        from: null,
        role: role
      },
      // fetchPolicy: "network-only",
      skip: !shouldFetch || !organisationId || !teamId
    }),
    projectListing = _useQuery4.data,
    projectListingError = _useQuery4.error,
    projectListingLoading = _useQuery4.loading,
    projectRefetch = _useQuery4.refetch;
  var _useMutation = useMutation(UPDATE_PROJECT_START_DATE_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateProjectStartDate = _useMutation2[0],
    updateProjectStartDateLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(UPDATE_PROJECT_END_DATE_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    updateProjectEndDate = _useMutation4[0],
    updateProjectEndDateLoading = _useMutation4[1].loading;

  // READY FLAG (DO NOT use dynamic checks inside)
  var isTaskTrackerReady = shouldFetch && !!organisationId && !!teamId && !!projectId;

  // MEMOIZED VARIABLES (only this)
  var taskTrackerVariablesMemo = React.useMemo(function () {
    return {
      organisationId: organisationId,
      teamId: teamId,
      userId: userActive.length ? userActive : null,
      projectId: projectActive.length ? projectActive : null,
      taskId: taskActive.length ? taskActive : null,
      limit: EMPLOYEE_LIMIT,
      offset: 0,
      startDate: Number(moment(startDate).format("x")),
      endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
      timeZone: timezone
    };
  }, [organisationId, teamId, userActive, projectActive, taskActive, startDate, endDate, timezone]);

  // LAZY QUERY
  var _useLazyQuery = useLazyQuery(GET_TASK_TRACKER_QUERY, {
      fetchPolicy: "cache-first" // IMPORTANT 🔥
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    loadTaskTracker = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    taskTrackerData = _useLazyQuery2$.data,
    taskTrackerError = _useLazyQuery2$.error,
    taskTrackerLoading = _useLazyQuery2$.loading,
    taskTrackerFetchMore = _useLazyQuery2$.fetchMore;

  // EFFECT (query will run only when variables truly change)
  React.useEffect(function () {
    if (isTaskTrackerReady) {
      loadTaskTracker({
        variables: taskTrackerVariablesMemo
      });
    }
  }, [isTaskTrackerReady, taskTrackerVariablesMemo]);
  React.useEffect(function () {
    setProjectDetailFetchs(true);
  }, [location]);
  var _useLazyQuery3 = useLazyQuery(PROJECT_EMPLOYEE_WISE_EARNING_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
        setExportLogButton(false);
        setExportTaskButton(false);
      }
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getExport = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    exportLoading = _useLazyQuery4$.loading,
    exportData = _useLazyQuery4$.data;
  var _useLazyQuery5 = useLazyQuery(TASK_WISE_COST_ANALYSIS_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
        setExportLogButton(false);
        setExportTaskButton(false);
      }
    }),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getTaskExport = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    exportTaskLoading = _useLazyQuery6$.loading,
    exportTaskData = _useLazyQuery6$.data;
  var _useLazyQuery7 = useLazyQuery(GET_EXPORT_TASK_TRACKER_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
        setExportLogButton(false);
        setExportTaskButton(false);
      }
    }),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 2),
    getLogExport = _useLazyQuery8[0],
    _useLazyQuery8$ = _useLazyQuery8[1],
    exportLogLoading = _useLazyQuery8$.loading,
    exportLogData = _useLazyQuery8$.data;

  // person wise earning export
  var xlsxData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.projectEmployeesWiseEarningExport;
          if (dataValues) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Team Member",
            key: "displayName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Hourly Rate",
            key: "billableRate",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Hours Logged",
            key: "workedHours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Tasks",
            key: "taskCount",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Total Cost",
            key: "totalCost",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Budget Share",
            key: "percent",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (users, index) {
            var displayName = users.displayName,
              billableRate = users.billableRate,
              workedHours = users.workedHours,
              taskCount = users.taskCount,
              totalCost = users.totalCost;
            var percent = null;
            if (billableRate && budget) {
              //percent = Math.min(100, Math.round((totalCost / budget) * 100));

              var raw = Number(totalCost) / Number(budget) * 100;
              var _percent = Number.isInteger(raw) ? raw : Number(raw.toFixed(2));
              //percent = (Number(totalCost) / Number(budget)) * 100;
            }
            ws.addRow({
              displayName: displayName,
              billableRate: billableRate ? "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(billableRate || 0, "/h") : "NA",
              workedHours: workedHours,
              taskCount: taskCount,
              totalCost: "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(totalCost || 0),
              percent: "".concat(percent, "%")
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          ws.getCell("F1").font = {
            bold: true
          };
          _context.next = 15;
          return wb.xlsx.writeBuffer();
        case 15:
          buf = _context.sent;
          fileName = "".concat(projectName, "-employee-wise-earning-summary.xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [exportData]);

  //task wise cost anallyzies
  var xlsxTaskData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dataValues = exportTaskData === null || exportTaskData === void 0 ? void 0 : exportTaskData.taskWiseCostAnalysisExport;
          if (dataValues) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Task Name",
            key: "taskName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Total Hours",
            key: "totalWorkedTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Total Cost",
            key: "totalCost",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Budget Share",
            key: "percent",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (users, index) {
            var taskName = users.taskName,
              totalWorkedTime = users.totalWorkedTime,
              totalCost = users.totalCost;
            var percent = null;
            if (totalCost && budget) {
              percent = Number(totalCost) / Number(budget) * 100;
              var raw = Number(totalCost) / Number(budget) * 100;
              percent = Number.isInteger(raw) ? raw : Number(raw.toFixed(2));
            }
            ws.addRow({
              taskName: taskName,
              totalWorkedTime: totalWorkedTime,
              totalCost: "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(totalCost || 0),
              percent: "".concat(percent, "%")
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          _context2.next = 13;
          return wb.xlsx.writeBuffer();
        case 13:
          buf = _context2.sent;
          fileName = "".concat(projectName, "-task-wise-cost-analysis.xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportTaskButton(false);
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [exportTaskData]);
  var csvLogData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _exportLogData$getExp;
    var dataArray, dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          dataArray = [];
          dataValues = exportLogData === null || exportLogData === void 0 ? void 0 : (_exportLogData$getExp = exportLogData.getExportReportLogTaskTrackerDetails) === null || _exportLogData$getExp === void 0 ? void 0 : _exportLogData$getExp.taskTrackerDatas;
          if (dataValues) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Date",
            key: "date",
            width: 10,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Team Member",
            key: "member",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Task",
            key: "task",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Hours Worked (hh:mm:ss)",
            key: "hours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Billable Rate ",
            key: "userBillableRate",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Cost ",
            key: "cost",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (users, index) {
            var user = users.user,
              totalTime = users.totalTime,
              taskName = users.taskName,
              taskDate = users.taskDate,
              billableRate = users.billableRate,
              totalCost = users.totalCost;
            var percent = null;
            if (totalCost && budget) {
              percent = Math.min(100, Math.round(totalCost / budget * 100));
            }
            ws.addRow({
              date: moment(taskDate).format("DD MMM YYYY"),
              member: user.displayName,
              task: taskName,
              hours: totalTime,
              userBillableRate: "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(billableRate, "/h "),
              cost: "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(totalCost || 0)
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          ws.getCell("F1").font = {
            bold: true
          };
          _context3.next = 16;
          return wb.xlsx.writeBuffer();
        case 16:
          buf = _context3.sent;
          fileName = "workfolio-".concat(projectName, "-project-report-").concat(moment(startDate).format("DD MMM YYYY"), ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportLogButton(false);
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [exportLogData]);
  React.useEffect(function () {
    xlsxData();
  }, [exportData]);
  React.useEffect(function () {
    xlsxTaskData();
  }, [exportTaskData]);
  React.useEffect(function () {
    csvLogData();
  }, [exportLogData]);
  var getExportData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                projectId: projectId,
                organisationId: organisationId
              }
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getExportData() {
      return _ref4.apply(this, arguments);
    };
  }();
  var getExportTaskData = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setExportTaskButton(true);
            getTaskExport({
              variables: {
                projectId: projectId,
                organisationId: organisationId
              }
            });
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getExportTaskData() {
      return _ref5.apply(this, arguments);
    };
  }();
  var getExportLogData = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            setExportLogButton(true);
            getLogExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userActive.length ? userActive : null,
                projectId: projectActive.length ? projectActive : null,
                taskId: taskActive.length ? taskActive : null,
                startDate: Number(moment(startDate).format("x")),
                endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
                timeZone: timezone
              }
            });
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getExportLogData() {
      return _ref6.apply(this, arguments);
    };
  }();

  //timelime data calculation
  var start = moment.unix(projectStartDate / 1000);
  var end = moment.unix(projectDeadline / 1000);
  var now = moment();
  var durationDays = null;
  var progressPercent = 0;
  if (projectStartDate && projectDeadline) {
    durationDays = end.diff(start, "days") + 1;
    var totalDuration = end.diff(start);
    var elapsedDuration = now.diff(start);

    // Clamp the percentage between 0 and 100
    // Explaination =  totalDuration = end.diff(start) gives the total project duration in milliseconds.

    // elapsedDuration = now.diff(start) gives how much time has passed since the start.

    // (elapsedDuration / totalDuration) * 100 gives the progress percentage.

    // Math.min(Math.max(...)) ensures the result stays between 0% and 100%, even if the current time is before the start or after the end.

    // .toFixed(2) keeps the progress to 2 decimal places.
    progressPercent = Math.round(Math.min(Math.max(elapsedDuration / totalDuration * 100, 0), 100));
  }
  var handleStartChange = function handleStartChange(date) {
    setManualDate(date);
    if (manualEndDate && date && date > manualEndDate) {
      setDateError("Start date cannot be after the deadline.");
    } else {
      setDateError("");
    }
  };
  var handleEndChange = function handleEndChange(date) {
    setManualEndDate(date);
    if (manualDate && date && date < manualDate) {
      setDateError("Deadline must be after the start date.");
    } else {
      setDateError("");
    }
  };

  // add start date
  var handleStartDateSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var variables, _response$data, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (!(!isStartDateHover || manualDate === "" || manualDate == null || dateError !== "")) {
            _context7.next = 4;
            break;
          }
          setStartDateHover(null);
          setManualDate("");
          return _context7.abrupt("return", null);
        case 4:
          if (!(manualEndDate && manualDate && manualDate > manualEndDate)) {
            _context7.next = 7;
            break;
          }
          setDateError("Start date cannot be after the deadline.");
          return _context7.abrupt("return", null);
        case 7:
          variables = {
            projectId: projectId,
            projectStartDate: moment(manualDate),
            organisationId: organisationId
          };
          _context7.prev = 8;
          _context7.next = 11;
          return updateProjectStartDate({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: MY_PROJECTS_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                timeZone: timezone,
                limit: LIMIT,
                offset: 0,
                filter: "all",
                role: role,
                search: ""
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDates).format("YYYY-MM-DD"),
                endDate: moment(endDates !== null && endDates !== void 0 ? endDates : startDates).format("YYYY-MM-DD"),
                timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                role: role,
                userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }]
          });
        case 11:
          response = _context7.sent;
          if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.updateProjectStartDate) {
            _context7.next = 14;
            break;
          }
          throw new Error("error");
        case 14:
          toast.success("Start Date added successfully!");
          setStartDateHover(null);
          setManualDate("");
          _context7.next = 22;
          break;
        case 19:
          _context7.prev = 19;
          _context7.t0 = _context7["catch"](8);
          toast.error("Error Occured, Try again later!");
        case 22:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[8, 19]]);
  })), [updateProjectStartDate, manualDate, isStartDateHover, dateError, manualEndDate]);

  // add end date
  var handleEndDateSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var variables, _response$data2, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!(!isEndDateHover || manualEndDate === "" || manualEndDate == null || dateError !== "")) {
            _context8.next = 4;
            break;
          }
          setEndDateHover(null);
          setManualEndDate("");
          return _context8.abrupt("return", null);
        case 4:
          if (manualDate && manualEndDate && manualEndDate < manualDate) {
            setDateError("Deadline must be after the start date.");
          }
          variables = {
            projectId: projectId,
            deadline: moment(manualEndDate),
            organisationId: organisationId
          };
          _context8.prev = 6;
          _context8.next = 9;
          return updateProjectEndDate({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: MY_PROJECTS_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                timeZone: timezone,
                limit: LIMIT,
                offset: 0,
                filter: "all",
                role: role,
                search: ""
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDates).format("YYYY-MM-DD"),
                endDate: moment(endDates !== null && endDates !== void 0 ? endDates : startDates).format("YYYY-MM-DD"),
                timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                role: role,
                userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }]
          });
        case 9:
          response = _context8.sent;
          if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.updateProjectEndDate) {
            _context8.next = 12;
            break;
          }
          throw new Error("error");
        case 12:
          toast.success("End Date added successfully!");
          setEndDateHover(null);
          setManualEndDate("");
          _context8.next = 20;
          break;
        case 17:
          _context8.prev = 17;
          _context8.t0 = _context8["catch"](6);
          toast.error("Error Occured, Try again later!");
        case 20:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[6, 17]]);
  })), [updateProjectEndDate, manualEndDate, manualDate, isEndDateHover, dateError]);
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "budget-header-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header-text"
  }, /*#__PURE__*/React.createElement(FiTarget, {
    className: "budget-summary-cards-whole-div-card-header-icon"
  }), "Budget")), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours"
  }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(budget).toLocaleString("en-IN")), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph"
  }, "Project allocation"))), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-line-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header-text"
  }, /*#__PURE__*/React.createElement(FiDollarSign, {
    className: "budget-summary-cards-whole-div-card-header-icon"
  }), "Spent")), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-content"
  }, (budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu === void 0 ? void 0 : _budgetDetailsData$bu.totalSpent) != null ? /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours project-summary-cards-whole-div-card-content-hours-yellow"
  }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu2 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu2 === void 0 ? void 0 : _budgetDetailsData$bu2.totalSpent).toLocaleString("en-IN")) : /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-disable"
  }, "No Budget Assigned"), (budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu3 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu3 === void 0 ? void 0 : _budgetDetailsData$bu3.spentPercentage) != null ? /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-div"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu4 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu4 === void 0 ? void 0 : _budgetDetailsData$bu4.spentPercentage,
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress"
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-text"
  }, budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu5 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu5 === void 0 ? void 0 : _budgetDetailsData$bu5.spentPercentage, "% complete", " ")) : null)), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-line-3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header-text"
  }, /*#__PURE__*/React.createElement(MdTrendingUp, {
    className: "budget-summary-cards-whole-div-card-header-icon"
  }), "Remaining")), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-content"
  }, (budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu6 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu6 === void 0 ? void 0 : _budgetDetailsData$bu6.remaining) != null ? Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu7 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu7 === void 0 ? void 0 : _budgetDetailsData$bu7.totalSpent) >= Number(budget) ? /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-over"
  }, "Budget Exceeded by", " ", currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu8 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu8 === void 0 ? void 0 : _budgetDetailsData$bu8.totalSpent) >= Number(budget) ? Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu9 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu9 === void 0 ? void 0 : _budgetDetailsData$bu9.overBudget).toLocaleString("en-IN") : Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu10 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu10 === void 0 ? void 0 : _budgetDetailsData$bu10.remaining).toLocaleString("en-IN")) : /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours project-summary-cards-whole-div-card-content-hours-color"
  }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu11 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu11 === void 0 ? void 0 : _budgetDetailsData$bu11.totalSpent) >= Number(budget) ? Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu12 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu12 === void 0 ? void 0 : _budgetDetailsData$bu12.overBudget).toLocaleString("en-IN") : Number(budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu13 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu13 === void 0 ? void 0 : _budgetDetailsData$bu13.remaining).toLocaleString("en-IN")) : /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-disable"
  }, "No Budget Assigned"), (budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu14 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu14 === void 0 ? void 0 : _budgetDetailsData$bu14.remainingPercent) != null ? /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph"
  }, budgetDetailsData === null || budgetDetailsData === void 0 ? void 0 : (_budgetDetailsData$bu15 = budgetDetailsData.budgetAndFinanceSummaryDetails) === null || _budgetDetailsData$bu15 === void 0 ? void 0 : _budgetDetailsData$bu15.remainingPercent, "% available") : null)), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-header-text"
  }, /*#__PURE__*/React.createElement(MdAccessTime, {
    className: "budget-summary-cards-whole-div-card-header-icon"
  }), "Total Hours")), /*#__PURE__*/React.createElement("div", {
    className: "budget-summary-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours"
  }, totalWorkedSec), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph"
  }, "Across ", summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectU = summaryData.projectUserWithAdminUserId) === null || _summaryData$projectU === void 0 ? void 0 : _summaryData$projectU.length, " team", " ", (summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectU2 = summaryData.projectUserWithAdminUserId) === null || _summaryData$projectU2 === void 0 ? void 0 : _summaryData$projectU2.length) <= 1 ? "member" : "members")))), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline"
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "budget-timeline-cards-whole-div-card-header-headline-icon"
  }), "Project Timeline & Budget Status"), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline-text"
  }, "Progress tracking and key project milestones")), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list-card"
  }, "Start Date"), projectStartDate ? /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list-card-value"
  }, moment.unix(projectStartDate / 1000).format("MMM DD, YYYY")) : isStartDateHover ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputGroup, {
    className: "project-details-card-footer-add-estimation-time-input-group-new"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    id: "task-start-date",
    dateFormat: "dd/MM/yyyy",
    selected: manualDate,
    onChange: handleStartChange
    //isClearable={true}
    ,
    className: "task-details-due-date-date-picker edit-project-deadline-picker",
    placeholderText: "Select a date",
    autoComplete: "off",
    maxDate: manualEndDate || null // Prevent selecting after deadline
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    className: "project-details-card-footer-add-estimation-time-button",
    onClick: function onClick(e) {
      handleStartDateSubmit();
    },
    disabled: updateProjectStartDateLoading
  }, updateProjectStartDateLoading ? /*#__PURE__*/React.createElement(VscLoading, {
    className: "project-details-card-footer-add-estimation-time-button-loader"
  }) : /*#__PURE__*/React.createElement(MdCheck, {
    className: "project-details-card-footer-add-estimation-time-button-icon"
  }))), dateError && /*#__PURE__*/React.createElement("div", {
    style: {
      color: "red",
      marginTop: "8px",
      fontSize: "0.875rem"
    }
  }, dateError)) : /*#__PURE__*/React.createElement("div", {
    className: "project-details-budject-span-texts",
    onClick: function onClick(e) {
      e.stopPropagation();
      setStartDateHover(true);
    }
  }, "Add project start date")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list-card"
  }, "Duration"), durationDays !== null ? /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list-card-value"
  }, durationDays, " days") : /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list-card-value-unavailable"
  }, "NA")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list-card"
  }, "Deadline"), projectDeadline ? /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-list-card-value"
  }, moment.unix(projectDeadline / 1000).format("MMM DD, YYYY")) : isEndDateHover ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputGroup, {
    className: "project-details-card-footer-add-estimation-time-input-group-new"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    id: "task-due-date",
    dateFormat: "dd/MM/yyyy",
    selected: manualEndDate,
    onChange: handleEndChange,
    isClearable: true,
    className: "task-details-due-date-date-picker edit-project-deadline-picker",
    placeholderText: "Select a date",
    autoComplete: "off"

    //minDate={manualDate || null} // Prevent selecting before start date
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    className: "project-details-card-footer-add-estimation-time-button",
    onClick: function onClick(e) {
      handleEndDateSubmit();
    },
    disabled: updateProjectEndDateLoading
  }, updateProjectEndDateLoading ? /*#__PURE__*/React.createElement(VscLoading, {
    className: "project-details-card-footer-add-estimation-time-button-loader"
  }) : /*#__PURE__*/React.createElement(MdCheck, {
    className: "project-details-card-footer-add-estimation-time-button-icon"
  }))), dateError && /*#__PURE__*/React.createElement("div", {
    style: {
      color: "red",
      marginTop: "8px",
      fontSize: "0.875rem"
    }
  }, dateError)) : /*#__PURE__*/React.createElement("div", {
    className: "project-details-budject-span-texts",
    onClick: function onClick(e) {
      e.stopPropagation();
      setEndDateHover(true);
    }
  }, "Add project deadline"))), projectStartDate && projectDeadline ? /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-progress-text"
  }, /*#__PURE__*/React.createElement("span", {
    className: "budget-timeline-cards-whole-div-card-content-progress-text-1"
  }, "Project Timeline Progress"), /*#__PURE__*/React.createElement("span", {
    className: "budget-timeline-cards-whole-div-card-content-progress-text-2"
  }, progressPercent, "% complete")), /*#__PURE__*/React.createElement(ProgressBar, {
    now: progressPercent,
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-budget"
  })) : null)), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline"
  }, /*#__PURE__*/React.createElement(FiUsers, {
    className: "budget-timeline-cards-whole-div-card-header-headline-icon"
  }), "Employee wise earning summary"), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline-text"
  }, "Individual contribution and labor costs breakdown")), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button",
    onClick: function onClick() {
      getExportData();
    }
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export"))), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-whole"
  }, /*#__PURE__*/React.createElement(TeamPerformance, {
    employeeWiseEarningData: employeeWiseEarningData,
    employeeWiseEarningLoading: employeeWiseEarningLoading,
    employeeWiseEarningError: employeeWiseEarningError,
    currenciesData: currenciesData,
    employeeWiseEarningFetchMore: employeeWiseEarningFetchMore,
    budget: budget,
    projectId: projectId,
    organisationId: organisationId,
    organisationBilling: organisationBilling
  }))), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline"
  }, /*#__PURE__*/React.createElement(RiFileChartLine, {
    className: "budget-timeline-cards-whole-div-card-header-headline-icon"
  }), "Task-wise Cost Analysis"), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline-text"
  }, "Individual task breakdown with hours and costs")), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportTaskButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button",
    onClick: function onClick() {
      getExportTaskData();
    }
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export"))), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-whole"
  }, /*#__PURE__*/React.createElement(TaskBudgetSummary, {
    taskData: taskData,
    taskLoading: taskLoading,
    taskError: taskError,
    taskFetchMore: taskFetchMore,
    budget: budget,
    currenciesData: currenciesData,
    projectId: projectId,
    organisationId: organisationId,
    organisationBilling: organisationBilling
  }))), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline"
  }, /*#__PURE__*/React.createElement(MdAccessTime, {
    className: "budget-timeline-cards-whole-div-card-header-headline-icon"
  }), "Detailed Work Log"), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-header-headline-text"
  }, "Complete timeline of logged hours with associated costs")), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportLogButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button",
    onClick: function onClick() {
      getExportLogData();
    }
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export"))), /*#__PURE__*/React.createElement("div", {
    className: "budget-timeline-cards-whole-div-card-content-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-filter-user-new"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("project-report-users-button-date-new project-report-users-button--new .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, arrayToStringOutput([startDate, endDate], timezone)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "page-content-wrapper-menu-filter-overlay-trigger"
  }, /*#__PURE__*/React.createElement(TimeFilter, {
    onFilterChange: onFilterChange,
    startDate: startDate,
    endDate: endDate,
    filterData: filterData,
    onClose: hideOverlay,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings
  }))), /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("project-report-users-button-date-new project-report-users-button--new .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, "Employee ", userActive.length ? " (".concat(userActive.length, ") ") : null), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "project-report-dropdown-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-drop-text"
  }, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
    isNavClick: isNavClick,
    setNavClick: setNavClick,
    projectListing: summaryData.projectUserWithAdminUserId,
    userActive: userActive,
    setUserActive: setUserActive,
    projectActive: projectActive,
    setProjectActive: setProjectActive,
    type: "user",
    setTaskActive: setTaskActive,
    taskActive: taskActive
  })))), /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("project-report-users-button-date-new project-report-users-button--new .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, "Task ", taskActive.length ? " (".concat(taskActive.length, ") ") : null, " "), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "project-report-dropdown-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-drop-text"
  }, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
    isNavClick: isNavClick,
    setNavClick: setNavClick,
    projectListing: projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje = projectListing.projectsListing) === null || _projectListing$proje === void 0 ? void 0 : _projectListing$proje.projects,
    userActive: userActive,
    setUserActive: setUserActive,
    projectActive: projectActive,
    setProjectActive: setProjectActive,
    type: "task",
    setTaskActive: setTaskActive,
    taskActive: taskActive
  }))))), /*#__PURE__*/React.createElement(TimeLogTable, {
    taskTrackerData: taskTrackerData,
    taskTrackerError: taskTrackerError,
    taskTrackerLoading: taskTrackerLoading,
    taskTrackerFetchMore: taskTrackerFetchMore,
    taskTrackerVariablesMemo: taskTrackerVariablesMemo,
    currenciesData: currenciesData
  }))));
};
var TeamPerformance = function TeamPerformance(_ref9) {
  var _employeeWiseEarningD2, _employeeWiseEarningD3, _employeeWiseEarningD4, _employeeWiseEarningD5;
  var employeeWiseEarningData = _ref9.employeeWiseEarningData,
    employeeWiseEarningLoading = _ref9.employeeWiseEarningLoading,
    employeeWiseEarningError = _ref9.employeeWiseEarningError,
    currenciesData = _ref9.currenciesData,
    employeeWiseEarningFetchMore = _ref9.employeeWiseEarningFetchMore,
    budget = _ref9.budget,
    projectId = _ref9.projectId,
    organisationId = _ref9.organisationId,
    organisationBilling = _ref9.organisationBilling;
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    isTaskAllLoaded = _React$useState32[0],
    setTaskIsAllLoaded = _React$useState32[1];
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    isTaskLoadingMore = _React$useState34[0],
    setTaskIsLoadingMore = _React$useState34[1];
  var _React$useState35 = React.useState(null),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    userModalShow = _React$useState36[0],
    setShow = _React$useState36[1];

  //load more
  function handleTabScroll(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      var _employeeWiseEarningD;
      if (employeeWiseEarningLoading) return;
      if (isTaskAllLoaded) return;
      setTaskIsLoadingMore(true);
      employeeWiseEarningFetchMore({
        variables: {
          offset: employeeWiseEarningData === null || employeeWiseEarningData === void 0 ? void 0 : (_employeeWiseEarningD = employeeWiseEarningData.projectEmployeesWiseEarning) === null || _employeeWiseEarningD === void 0 ? void 0 : _employeeWiseEarningD.length
        },
        updateQuery: function updateQuery(prev, _ref10) {
          var fetchMoreResult = _ref10.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.projectEmployeesWiseEarning.length < EMPLOYEE_LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          }
          setTaskIsLoadingMore(false);
          var NewFilterData = [];
          fetchMoreResult.projectEmployeesWiseEarning.forEach(function (newTask) {
            var found = prev.projectEmployeesWiseEarning.find(function (item) {
              return item.userId === newTask.userId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            projectEmployeesWiseEarning: [].concat(_toConsumableArray(prev.projectEmployeesWiseEarning), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }
  var handleShow = function handleShow(displayName, workedHours, billableRate, totalCost, userId) {
    var temp = {
      displayName: displayName,
      workedHours: workedHours,
      billableRate: billableRate,
      totalCost: totalCost,
      userId: userId
    };
    setShow(temp);
  };
  var handleUserClose = function handleUserClose() {
    setShow(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "team-performance-wrapper"
  }, employeeWiseEarningLoading ? /*#__PURE__*/React.createElement(Loader, null) : employeeWiseEarningError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (employeeWiseEarningData === null || employeeWiseEarningData === void 0 ? void 0 : (_employeeWiseEarningD2 = employeeWiseEarningData.projectEmployeesWiseEarning) === null || _employeeWiseEarningD2 === void 0 ? void 0 : _employeeWiseEarningD2.length) == 0 ? /*#__PURE__*/React.createElement("p", {
    className: "emplyees-data-no"
  }, "No data found.") : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "team-performance-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Team Member"), /*#__PURE__*/React.createElement("th", null, "Hourly Rate"), /*#__PURE__*/React.createElement("th", null, "Hours Logged"), /*#__PURE__*/React.createElement("th", null, "Tasks"), /*#__PURE__*/React.createElement("th", null, "Total Cost"), /*#__PURE__*/React.createElement("th", null, "Budget Share"))), /*#__PURE__*/React.createElement("tbody", null, employeeWiseEarningData === null || employeeWiseEarningData === void 0 ? void 0 : (_employeeWiseEarningD3 = employeeWiseEarningData.projectEmployeesWiseEarning) === null || _employeeWiseEarningD3 === void 0 ? void 0 : _employeeWiseEarningD3.map(function (list, index) {
    var displayName = list.displayName,
      workedHours = list.workedHours,
      taskCount = list.taskCount,
      billableRate = list.billableRate,
      totalCost = list.totalCost,
      userId = list.userId;

    // let percent = null;
    var percents = null;
    if (billableRate && budget) {
      // percent = Math.min(100, Math.round((totalCost / budget) * 100));
      // percents = (Number(totalCost) / Number(budget)) * 100;

      var raw = Number(totalCost) / Number(budget) * 100;
      percents = Number.isInteger(raw) ? raw : Number(raw.toFixed(2));
    }
    return /*#__PURE__*/React.createElement("tr", {
      key: index,
      onClick: function onClick(e) {
        e.stopPropagation();
        handleShow(displayName, workedHours, billableRate, totalCost, userId);
      }
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "member-info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "member-avatar"
    }, displayName === null || displayName === void 0 ? void 0 : displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "member-name"
    }, displayName))), /*#__PURE__*/React.createElement("td", null, billableRate ? /*#__PURE__*/React.createElement("div", {
      className: "pill"
    }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(billableRate).toLocaleString("en-IN") || 0, "/h") : /*#__PURE__*/React.createElement("div", {
      className: "pill"
    }, /*#__PURE__*/React.createElement("span", {
      className: "budget-na-text"
    }, " NA "))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "pill"
    }, workedHours)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "task-pill"
    }, taskCount)), /*#__PURE__*/React.createElement("td", null, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(totalCost).toLocaleString("en-IN") || 0), /*#__PURE__*/React.createElement("td", null, percents ? /*#__PURE__*/React.createElement("div", {
      className: "budget-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "budget-percent"
    }, Number(percents).toLocaleString("en-IN"), "%")) : /*#__PURE__*/React.createElement("div", {
      className: "budget-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "budget-percent"
    }, 0, "%"))));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-details-task-management-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 3
  }, employeeWiseEarningData !== null && employeeWiseEarningData !== void 0 && (_employeeWiseEarningD4 = employeeWiseEarningData.projectEmployeesWiseEarning) !== null && _employeeWiseEarningD4 !== void 0 && _employeeWiseEarningD4.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (employeeWiseEarningData === null || employeeWiseEarningData === void 0 ? void 0 : (_employeeWiseEarningD5 = employeeWiseEarningData.projectEmployeesWiseEarning) === null || _employeeWiseEarningD5 === void 0 ? void 0 : _employeeWiseEarningD5.length) < EMPLOYEE_LIMIT || isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the employee") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll(e);
    }
  }, "Load more"))) : null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null))))), /*#__PURE__*/React.createElement(UserWiseEarningModal, {
    userModalShow: userModalShow,
    handleUserClose: handleUserClose,
    currenciesData: currenciesData,
    projectId: projectId,
    organisationId: organisationId,
    organisationBilling: organisationBilling
  }));
};
var TaskBudgetSummary = function TaskBudgetSummary(_ref11) {
  var _taskData$taskWiseCos2, _taskData$taskWiseCos3, _taskData$taskWiseCos4, _taskData$taskWiseCos5;
  var taskData = _ref11.taskData,
    taskLoading = _ref11.taskLoading,
    taskError = _ref11.taskError,
    taskFetchMore = _ref11.taskFetchMore,
    budget = _ref11.budget,
    currenciesData = _ref11.currenciesData,
    projectId = _ref11.projectId,
    organisationId = _ref11.organisationId,
    organisationBilling = _ref11.organisationBilling;
  var _React$useState37 = React.useState(false),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    isTaskAllLoaded = _React$useState38[0],
    setTaskIsAllLoaded = _React$useState38[1];
  var _React$useState39 = React.useState(false),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    isTaskLoadingMore = _React$useState40[0],
    setTaskIsLoadingMore = _React$useState40[1];
  var _React$useState41 = React.useState(null),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    userModalShow = _React$useState42[0],
    setShow = _React$useState42[1];

  //load more
  function handleTabScroll(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      var _taskData$taskWiseCos;
      if (taskLoading) return;
      if (isTaskAllLoaded) return;
      setTaskIsLoadingMore(true);
      taskFetchMore({
        variables: {
          offset: taskData === null || taskData === void 0 ? void 0 : (_taskData$taskWiseCos = taskData.taskWiseCostAnalysis) === null || _taskData$taskWiseCos === void 0 ? void 0 : _taskData$taskWiseCos.length
        },
        updateQuery: function updateQuery(prev, _ref12) {
          var fetchMoreResult = _ref12.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.taskWiseCostAnalysis.length < EMPLOYEE_LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          }
          setTaskIsLoadingMore(false);
          var NewFilterData = [];
          fetchMoreResult.taskWiseCostAnalysis.forEach(function (newTask) {
            var found = prev.taskWiseCostAnalysis.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            taskWiseCostAnalysis: [].concat(_toConsumableArray(prev.taskWiseCostAnalysis), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }
  var handleShow = function handleShow(taskName, totalWorkedTime, totalCost, taskId) {
    var temp = {
      taskName: taskName,
      totalWorkedTime: totalWorkedTime,
      totalCost: totalCost,
      taskId: taskId
    };
    setShow(temp);
  };
  var handleUserClose = function handleUserClose() {
    setShow(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "task-budget-summary-wrapper"
  }, taskLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (taskData === null || taskData === void 0 ? void 0 : (_taskData$taskWiseCos2 = taskData.taskWiseCostAnalysis) === null || _taskData$taskWiseCos2 === void 0 ? void 0 : _taskData$taskWiseCos2.length) == 0 ? /*#__PURE__*/React.createElement("p", {
    className: "emplyees-data-no"
  }, "No data found.") : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "task-budget-summary-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Task Name"), /*#__PURE__*/React.createElement("th", null, "Total Hours"), /*#__PURE__*/React.createElement("th", null, "Total Cost"), /*#__PURE__*/React.createElement("th", null, "Budget Share"))), /*#__PURE__*/React.createElement("tbody", null, taskData === null || taskData === void 0 ? void 0 : (_taskData$taskWiseCos3 = taskData.taskWiseCostAnalysis) === null || _taskData$taskWiseCos3 === void 0 ? void 0 : _taskData$taskWiseCos3.map(function (task, index) {
    var taskId = task.taskId,
      taskName = task.taskName,
      totalWorkedTime = task.totalWorkedTime,
      totalCost = task.totalCost;

    // let budgetShare = null;
    var budgetShares = null;
    if (totalCost && budget) {
      //budgetShare = ((totalCost / budget) * 100).toFixed(2);
      //budgetShare = Math.min(100, Math.round((totalCost / budget) * 100));
      //budgetShares = (Number(totalCost) / Number(budget)) * 100;

      var raw = Number(totalCost) / Number(budget) * 100;
      budgetShares = Number.isInteger(raw) ? raw : Number(raw.toFixed(2));
    }
    return /*#__PURE__*/React.createElement("tr", {
      key: taskId,
      onClick: function onClick(e) {
        e.stopPropagation();
        handleShow(taskName, totalWorkedTime, totalCost, taskId);
      }
    }, /*#__PURE__*/React.createElement("td", {
      className: "task-name-cell"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-name-wrapper"
    }, taskName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "task-hours-pill"
    }, totalWorkedTime)), /*#__PURE__*/React.createElement("td", null, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(totalCost).toLocaleString("en-IN") || 0), /*#__PURE__*/React.createElement("td", null, budgetShares ? /*#__PURE__*/React.createElement("div", {
      className: "budget-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "budget-percent"
    }, Number(budgetShares).toLocaleString("en-IN"), "%")) : /*#__PURE__*/React.createElement("div", {
      className: "budget-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "budget-percent"
    }, 0, "%"))));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-details-task-management-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 1
  }, taskData !== null && taskData !== void 0 && (_taskData$taskWiseCos4 = taskData.taskWiseCostAnalysis) !== null && _taskData$taskWiseCos4 !== void 0 && _taskData$taskWiseCos4.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (taskData === null || taskData === void 0 ? void 0 : (_taskData$taskWiseCos5 = taskData.taskWiseCostAnalysis) === null || _taskData$taskWiseCos5 === void 0 ? void 0 : _taskData$taskWiseCos5.length) < EMPLOYEE_LIMIT || isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the employee") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll(e);
    }
  }, "Load more"))) : null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null))))), /*#__PURE__*/React.createElement(TaskWiseUserModal, {
    userModalShow: userModalShow,
    handleUserClose: handleUserClose,
    currenciesData: currenciesData,
    projectId: projectId,
    organisationId: organisationId,
    organisationBilling: organisationBilling
  }));
};
var TimeLogTable = function TimeLogTable(_ref13) {
  var _taskTrackerData$getR2, _taskTrackerData$getR3, _taskTrackerData$getR4, _taskTrackerData$getR5, _taskTrackerData$getR6, _taskTrackerData$getR7;
  var taskTrackerData = _ref13.taskTrackerData,
    taskTrackerError = _ref13.taskTrackerError,
    taskTrackerLoading = _ref13.taskTrackerLoading,
    taskTrackerFetchMore = _ref13.taskTrackerFetchMore,
    taskTrackerVariablesMemo = _ref13.taskTrackerVariablesMemo,
    currenciesData = _ref13.currenciesData;
  var _React$useState43 = React.useState(false),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    isTaskAllLoaded = _React$useState44[0],
    setTaskIsAllLoaded = _React$useState44[1];
  var _React$useState45 = React.useState(false),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    isTaskLoadingMore = _React$useState46[0],
    setTaskIsLoadingMore = _React$useState46[1];

  //load more
  // const handleLoadMore = (e) => {
  //   // const currentRows = taskTrackerData?.getReportLogTaskTrackerDetails?.taskTrackerDatas || [];
  //   // const newOffset = currentRows.length;

  //   // taskTrackerFetchMore({
  //   //   variables: {
  //   //     ...taskTrackerVariablesMemo, // include other required fields
  //   //     offset: newOffset,
  //   //   },
  //   //   updateQuery: (prev, { fetchMoreResult }) => {
  //   //     if (!fetchMoreResult) return prev;

  //   //     return {
  //   //       ...prev,
  //   //       getReportLogTaskTrackerDetails: {
  //   //         ...prev.getReportLogTaskTrackerDetails,
  //   //         taskTrackerDatas: [
  //   //           ...prev.getReportLogTaskTrackerDetails.taskTrackerDatas,
  //   //           ...fetchMoreResult.getReportLogTaskTrackerDetails.taskTrackerDatas
  //   //         ]
  //   //       }
  //   //     };
  //   //   }
  //   // });

  // };

  var handleLoadMore = function handleLoadMore() {
    var _taskTrackerData$getR;
    if (taskTrackerLoading) return;
    if (isTaskAllLoaded) return;
    setTaskIsLoadingMore(true);
    var currentRows = (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR = taskTrackerData.getReportLogTaskTrackerDetails) === null || _taskTrackerData$getR === void 0 ? void 0 : _taskTrackerData$getR.taskTrackerDatas) || [];
    var newOffset = currentRows.length;
    taskTrackerFetchMore({
      variables: _objectSpread(_objectSpread({}, taskTrackerVariablesMemo), {}, {
        offset: newOffset
      }),
      updateQuery: function updateQuery(prev, _ref14) {
        var fetchMoreResult = _ref14.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        var newRows = fetchMoreResult.getReportLogTaskTrackerDetails.taskTrackerDatas;

        // 🔥 FIXED: CHECK CORRECT PROPERTY
        if (newRows.length < EMPLOYEE_LIMIT) {
          setTaskIsAllLoaded(true);
        }
        setTaskIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getReportLogTaskTrackerDetails: _objectSpread(_objectSpread({}, prev.getReportLogTaskTrackerDetails), {}, {
            taskTrackerDatas: [].concat(_toConsumableArray(prev.getReportLogTaskTrackerDetails.taskTrackerDatas), _toConsumableArray(newRows))
          })
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "time-log-table-wrapper"
  }, taskTrackerLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskTrackerError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR2 = taskTrackerData.getReportLogTaskTrackerDetails) === null || _taskTrackerData$getR2 === void 0 ? void 0 : (_taskTrackerData$getR3 = _taskTrackerData$getR2.taskTrackerDatas) === null || _taskTrackerData$getR3 === void 0 ? void 0 : _taskTrackerData$getR3.length) == 0 ? /*#__PURE__*/React.createElement("p", {
    className: "emplyees-data-no"
  }, "No data found.") : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "time-log-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Date"), /*#__PURE__*/React.createElement("th", null, "Team Member"), /*#__PURE__*/React.createElement("th", null, "Task"), /*#__PURE__*/React.createElement("th", null, "Hours (hh:mm:ss)"), /*#__PURE__*/React.createElement("th", null, "Rate"), /*#__PURE__*/React.createElement("th", null, "Cost"))), /*#__PURE__*/React.createElement("tbody", null, taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR4 = taskTrackerData.getReportLogTaskTrackerDetails) === null || _taskTrackerData$getR4 === void 0 ? void 0 : (_taskTrackerData$getR5 = _taskTrackerData$getR4.taskTrackerDatas) === null || _taskTrackerData$getR5 === void 0 ? void 0 : _taskTrackerData$getR5.map(function (log, index) {
    var taskDate = log.taskDate,
      user = log.user,
      taskName = log.taskName,
      totalTime = log.totalTime,
      billableRate = log.billableRate,
      totalCost = log.totalCost;
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", {
      className: "date-cell"
    }, moment(taskDate).format("DD MMM YYYY")), /*#__PURE__*/React.createElement("td", null, user.displayName), /*#__PURE__*/React.createElement("td", null, taskName), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "hours-pill"
    }, totalTime)), /*#__PURE__*/React.createElement("td", null, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(billableRate).toLocaleString("en-IN"), "/h"), /*#__PURE__*/React.createElement("td", null, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(totalCost).toLocaleString("en-IN")));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-details-task-management-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 1
  }, taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getR6 = taskTrackerData.getReportLogTaskTrackerDetails) !== null && _taskTrackerData$getR6 !== void 0 && (_taskTrackerData$getR7 = _taskTrackerData$getR6.taskTrackerDatas) !== null && _taskTrackerData$getR7 !== void 0 && _taskTrackerData$getR7.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the employee") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: handleLoadMore
  }, "Load more"))) : null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)))));
};
var ProjectAndTaskList = function ProjectAndTaskList(props) {
  var _userWithSearch, _userWithSearch2, _taskWithSearch, _taskWithSearch2;
  var isNavClick = props.isNavClick,
    setNavClick = props.setNavClick,
    projectListing = props.projectListing,
    userActive = props.userActive,
    setUserActive = props.setUserActive,
    projectActive = props.projectActive,
    setProjectActive = props.setProjectActive,
    type = props.type,
    setTaskActive = props.setTaskActive,
    taskActive = props.taskActive;
  var _React$useState47 = React.useState(""),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    searchUser = _React$useState48[0],
    setSearchUser = _React$useState48[1]; // SEARCH SETTINGS

  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  var projectWithSearch = function projectWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$proj, _filterUsersData$proj2, _filterUsersData$proj3, _filterUsersData$proj4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$proj = filterUsersData.projectName) === null || _filterUsersData$proj === void 0 ? void 0 : (_filterUsersData$proj2 = _filterUsersData$proj.toLowerCase) === null || _filterUsersData$proj2 === void 0 ? void 0 : (_filterUsersData$proj3 = _filterUsersData$proj2.call(_filterUsersData$proj)) === null || _filterUsersData$proj3 === void 0 ? void 0 : (_filterUsersData$proj4 = _filterUsersData$proj3.includes) === null || _filterUsersData$proj4 === void 0 ? void 0 : _filterUsersData$proj4.call(_filterUsersData$proj3, searchUser.toLowerCase());
    });
  };
  var taskWithSearch = function taskWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$task, _filterUsersData$task2, _filterUsersData$task3, _filterUsersData$task4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$task = filterUsersData.taskName) === null || _filterUsersData$task === void 0 ? void 0 : (_filterUsersData$task2 = _filterUsersData$task.toLowerCase) === null || _filterUsersData$task2 === void 0 ? void 0 : (_filterUsersData$task3 = _filterUsersData$task2.call(_filterUsersData$task)) === null || _filterUsersData$task3 === void 0 ? void 0 : (_filterUsersData$task4 = _filterUsersData$task3.includes) === null || _filterUsersData$task4 === void 0 ? void 0 : _filterUsersData$task4.call(_filterUsersData$task3, searchUser.toLowerCase());
    });
  };
  var taskList = [];
  React.useEffect(function () {
    projectListing.map(function (item) {
      var projectName = item.projectName,
        projectId = item.projectId,
        tasks = item.tasks;
      if (projectActive.includes(projectId)) {
        tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
          return taskList.push({
            taskName: data.taskName,
            taskId: data.taskId
          });
        });
      }
    });
  }, [projectActive]);
  if (type == "task") {
    projectListing.map(function (item) {
      var projectName = item.projectName,
        projectId = item.projectId,
        tasks = item.tasks;
      if (projectActive.includes(projectId)) {
        tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
          return taskList.push({
            taskName: data.taskName,
            taskId: data.taskId
          });
        });
      }
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "navbar-collapse-project-task-list-card-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: type == "project" ? "Search project name" : type === "user" ? "Search employee name" : "Search task name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "navbar-collapse-project-task-list-card-searchbox-wrapper-div"
  }), /*#__PURE__*/React.createElement("div", {
    id: "project-and-task-selection-navbar",
    className: "navbar-collapse-project-task project-and-task-selection-navbar-collapse project-and-task-selection-collapse ".concat(isNavClick ? "in" : "")
  }, type == "user" ? projectListing && (_userWithSearch = userWithSearch(projectListing)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(projectListing)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox"
      //id={user.userId}
      ,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: !userActive.length,
      onChange: function onChange() {
        setUserActive([]);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, "A"), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setUserActive([]);
      }
    }, "All Members"))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }), user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.displayName)))) : /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }), user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.displayName))));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\" ")) : (_taskWithSearch = taskWithSearch(taskList)) !== null && _taskWithSearch !== void 0 && _taskWithSearch.length ? (_taskWithSearch2 = taskWithSearch(taskList)) === null || _taskWithSearch2 === void 0 ? void 0 : _taskWithSearch2.map(function (user, index) {
    var teamFirstName = user.taskName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.taskId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: !taskActive.length,
      onChange: function onChange() {
        setTaskActive([]);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, "A"), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setTaskActive([]);
      }
    }, "All tasks"))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.taskId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: taskActive.includes(user.taskId),
      onChange: function onChange() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.taskName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }, user.taskName)))) : /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.taskId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: taskActive.includes(user.taskId),
      onChange: function onChange() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.taskName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }, user.taskName))));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No task found for \"".concat(searchUser, "\" "))));
};

// user wise earning modal
var UserWiseEarningModal = function UserWiseEarningModal(props) {
  var _tasksOptionsData$get2, _tasksOptionsData$get3, _tasksOptionsData$get4, _tasksOptionsData$get5;
  var userModalShow = props.userModalShow,
    handleUserClose = props.handleUserClose,
    currenciesData = props.currenciesData,
    projectId = props.projectId,
    organisationId = props.organisationId,
    organisationBilling = props.organisationBilling;
  if (userModalShow === null) {
    return null;
  }
  var displayName = userModalShow.displayName,
    workedHours = userModalShow.workedHours,
    billableRate = userModalShow.billableRate,
    totalCost = userModalShow.totalCost,
    userId = userModalShow.userId;
  var _useQuery5 = useQuery(PROJECT_USER_WISE_TASK_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId,
        userId: userId,
        limit: EMPLOYEE_LIMIT,
        offset: 0
      },
      skip: !organisationId
    }),
    tasksOptionsData = _useQuery5.data,
    tasksOptionsError = _useQuery5.error,
    tasksOptionsLoading = _useQuery5.loading,
    employeeWiseEarningFetchMore = _useQuery5.fetchMore;
  var _React$useState49 = React.useState(false),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    isTaskAllLoaded = _React$useState50[0],
    setTaskIsAllLoaded = _React$useState50[1];
  var _React$useState51 = React.useState(false),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    isTaskLoadingMore = _React$useState52[0],
    setTaskIsLoadingMore = _React$useState52[1];
  var _React$useState53 = React.useState(false),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    exportButton = _React$useState54[0],
    setExportButton = _React$useState54[1];
  var _useLazyQuery9 = useLazyQuery(PROJECT_USER_WISE_TASK_LISTING_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    getExport = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    exportLoading = _useLazyQuery10$.loading,
    exportData = _useLazyQuery10$.data;

  //load more
  function handleTabScroll(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      var _tasksOptionsData$get;
      if (tasksOptionsLoading) return;
      if (isTaskAllLoaded) return;
      setTaskIsLoadingMore(true);
      employeeWiseEarningFetchMore({
        variables: {
          offset: tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get = tasksOptionsData.getUserWiseTaskListingModal) === null || _tasksOptionsData$get === void 0 ? void 0 : _tasksOptionsData$get.length
        },
        updateQuery: function updateQuery(prev, _ref15) {
          var fetchMoreResult = _ref15.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.getUserWiseTaskListingModal.length < EMPLOYEE_LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          }
          setTaskIsLoadingMore(false);
          var NewFilterData = [];
          fetchMoreResult.getUserWiseTaskListingModal.forEach(function (newTask) {
            var found = prev.getUserWiseTaskListingModal.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            getUserWiseTaskListingModal: [].concat(_toConsumableArray(prev.getUserWiseTaskListingModal), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }

  // person wise earning export
  var xlsxData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.getUserWiseTaskListingModalExport;
          if (dataValues) {
            _context9.next = 3;
            break;
          }
          return _context9.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Task",
            key: "taskName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Hours",
            key: "totalTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Cost",
            key: "totalCost",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (users, index) {
            var taskName = users.taskName,
              totalTime = users.totalTime,
              totalCost = users.totalCost;
            ws.addRow({
              taskName: taskName,
              totalTime: totalTime,
              totalCost: "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(totalCost || 0)
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          _context9.next = 12;
          return wb.xlsx.writeBuffer();
        case 12:
          buf = _context9.sent;
          fileName = "Tasks-by-".concat(displayName, ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 16:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  })), [exportData]);
  React.useEffect(function () {
    xlsxData();
  }, [exportData]);
  var getExportData = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                userId: userId
              }
            });
          case 2:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function getExportData() {
      return _ref17.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleUserClose,
    size: "lg",
    centered: true,
    className: "my-projects-modal-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "my-projects-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-whole-header"
  }, /*#__PURE__*/React.createElement(FiUser, null), " ", /*#__PURE__*/React.createElement("div", null, "Tasks by ", displayName)))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers-1"
  }, "Total Hours: ", workedHours), /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers-1"
  }, "Hourly Rate:", " ", billableRate ? /*#__PURE__*/React.createElement("div", {
    className: "pill"
  }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(billableRate).toLocaleString("en-IN") || 0, "/h") : /*#__PURE__*/React.createElement("div", {
    className: "pill"
  }, /*#__PURE__*/React.createElement("span", {
    className: "budget-na-text"
  }, " NA "))), /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers-1"
  }, "Total Cost:", " ", currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(totalCost).toLocaleString("en-IN") || 0)), /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Export is unavailable due to maintenance. It will be back within 24 hours. Sorry for the inconvenience.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export"))), /*#__PURE__*/React.createElement("div", null, tasksOptionsLoading ? /*#__PURE__*/React.createElement(Loader, null) : tasksOptionsError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get2 = tasksOptionsData.getUserWiseTaskListingModal) === null || _tasksOptionsData$get2 === void 0 ? void 0 : _tasksOptionsData$get2.length) == 0 ? /*#__PURE__*/React.createElement("p", {
    className: "emplyees-data-no"
  }, "No data found.") : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "team-performance-table-modal"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Task"), /*#__PURE__*/React.createElement("th", null, "Hours"), /*#__PURE__*/React.createElement("th", null, "Cost"))), /*#__PURE__*/React.createElement("tbody", null, tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get3 = tasksOptionsData.getUserWiseTaskListingModal) === null || _tasksOptionsData$get3 === void 0 ? void 0 : _tasksOptionsData$get3.map(function (list, index) {
    var totalTimeInSec = list.totalTimeInSec,
      totalTime = list.totalTime,
      taskId = list.taskId,
      taskName = list.taskName,
      taskDate = list.taskDate,
      billableRate = list.billableRate,
      totalCost = list.totalCost;
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "member-info-modal"
    }, /*#__PURE__*/React.createElement("div", {
      className: "member-name-modal"
    }, taskName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "pill"
    }, totalTime)), /*#__PURE__*/React.createElement("td", null, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$", Number(totalCost).toLocaleString("en-IN") || 0));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-details-task-management-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 3
  }, tasksOptionsData !== null && tasksOptionsData !== void 0 && (_tasksOptionsData$get4 = tasksOptionsData.getUserWiseTaskListingModal) !== null && _tasksOptionsData$get4 !== void 0 && _tasksOptionsData$get4.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get5 = tasksOptionsData.getUserWiseTaskListingModal) === null || _tasksOptionsData$get5 === void 0 ? void 0 : _tasksOptionsData$get5.length) < EMPLOYEE_LIMIT || isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll(e);
    }
  }, "Load more"))) : null))))))));
};
// task wise user modal
var TaskWiseUserModal = function TaskWiseUserModal(props) {
  var _tasksOptionsData$get7, _tasksOptionsData$get8, _tasksOptionsData$get9, _tasksOptionsData$get10;
  var userModalShow = props.userModalShow,
    handleUserClose = props.handleUserClose,
    currenciesData = props.currenciesData,
    projectId = props.projectId,
    organisationId = props.organisationId,
    organisationBilling = props.organisationBilling;
  if (userModalShow === null) {
    return null;
  }
  var taskName = userModalShow.taskName,
    totalWorkedTime = userModalShow.totalWorkedTime,
    totalCost = userModalShow.totalCost,
    taskId = userModalShow.taskId;
  var _useQuery6 = useQuery(TASK_WISE_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId,
        taskId: taskId,
        limit: EMPLOYEE_LIMIT,
        offset: 0
      },
      skip: !organisationId
    }),
    tasksOptionsData = _useQuery6.data,
    tasksOptionsError = _useQuery6.error,
    tasksOptionsLoading = _useQuery6.loading,
    employeeWiseEarningFetchMore = _useQuery6.fetchMore;
  var _React$useState55 = React.useState(false),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    isTaskAllLoaded = _React$useState56[0],
    setTaskIsAllLoaded = _React$useState56[1];
  var _React$useState57 = React.useState(false),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    isTaskLoadingMore = _React$useState58[0],
    setTaskIsLoadingMore = _React$useState58[1];
  var _React$useState59 = React.useState(false),
    _React$useState60 = _slicedToArray(_React$useState59, 2),
    exportButton = _React$useState60[0],
    setExportButton = _React$useState60[1];
  var _useLazyQuery11 = useLazyQuery(TASK_WISE_USER_LISTING_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    getExport = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    exportLoading = _useLazyQuery12$.loading,
    exportData = _useLazyQuery12$.data;

  //load more
  function handleTabScroll(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      var _tasksOptionsData$get6;
      if (tasksOptionsLoading) return;
      if (isTaskAllLoaded) return;
      setTaskIsLoadingMore(true);
      employeeWiseEarningFetchMore({
        variables: {
          offset: tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get6 = tasksOptionsData.gettaskWiseUserListingModal) === null || _tasksOptionsData$get6 === void 0 ? void 0 : _tasksOptionsData$get6.length
        },
        updateQuery: function updateQuery(prev, _ref18) {
          var fetchMoreResult = _ref18.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.gettaskWiseUserListingModal.length < EMPLOYEE_LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          }
          setTaskIsLoadingMore(false);
          var NewFilterData = [];
          fetchMoreResult.gettaskWiseUserListingModal.forEach(function (newTask) {
            var found = prev.gettaskWiseUserListingModal.find(function (item) {
              return item.userId === newTask.userId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            gettaskWiseUserListingModal: [].concat(_toConsumableArray(prev.gettaskWiseUserListingModal), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }

  // task wise user export
  var xlsxData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.gettaskWiseUserListingModalExport;
          if (dataValues) {
            _context11.next = 3;
            break;
          }
          return _context11.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Team Member",
            key: "displayName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Hours",
            key: "totalTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Rate",
            key: "billableRate",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Cost",
            key: "totalCost",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (users, index) {
            var displayName = users.displayName,
              totalTime = users.totalTime,
              billableRate = users.billableRate,
              totalCost = users.totalCost;
            ws.addRow({
              displayName: displayName,
              totalTime: totalTime,
              billableRate: billableRate ? "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(billableRate || 0, "/h") : "NA",
              totalCost: "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$").concat(totalCost || 0)
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          _context11.next = 13;
          return wb.xlsx.writeBuffer();
        case 13:
          buf = _context11.sent;
          fileName = "".concat(taskName, ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 17:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  })), [exportData]);
  React.useEffect(function () {
    xlsxData();
  }, [exportData]);
  var getExportData = /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                taskId: taskId
              }
            });
          case 2:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function getExportData() {
      return _ref20.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleUserClose,
    size: "lg",
    centered: true,
    className: "my-projects-modal-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "my-projects-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-whole-header"
  }, /*#__PURE__*/React.createElement(FiFileText, null), " ", /*#__PURE__*/React.createElement("div", null, " ", taskName)))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers-1"
  }, "Total Hours: ", totalWorkedTime), /*#__PURE__*/React.createElement("div", {
    className: "project-user-wise-budget-earning-modal-headers-1"
  }, "Total Cost:", " ", currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(totalCost).toLocaleString("en-IN") || 0)), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button",
    onClick: function onClick() {
      getExportData();
    }
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export"))), /*#__PURE__*/React.createElement("div", null, tasksOptionsLoading ? /*#__PURE__*/React.createElement(Loader, null) : tasksOptionsError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get7 = tasksOptionsData.gettaskWiseUserListingModal) === null || _tasksOptionsData$get7 === void 0 ? void 0 : _tasksOptionsData$get7.length) == 0 ? /*#__PURE__*/React.createElement("p", {
    className: "emplyees-data-no"
  }, "No data found.") : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "team-performance-table-modal"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Team Member"), /*#__PURE__*/React.createElement("th", null, "Hours"), /*#__PURE__*/React.createElement("th", null, "Rate"), /*#__PURE__*/React.createElement("th", null, "Cost"))), /*#__PURE__*/React.createElement("tbody", null, tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get8 = tasksOptionsData.gettaskWiseUserListingModal) === null || _tasksOptionsData$get8 === void 0 ? void 0 : _tasksOptionsData$get8.map(function (list, index) {
    var totalTime = list.totalTime,
      userId = list.userId,
      displayName = list.displayName,
      profileUrl = list.profileUrl,
      billableRate = list.billableRate,
      totalCost = list.totalCost;
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "member-info-modal"
    }, /*#__PURE__*/React.createElement("div", {
      className: "member-name-modal"
    }, displayName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "pill"
    }, totalTime)), /*#__PURE__*/React.createElement("td", null, billableRate ? /*#__PURE__*/React.createElement("div", {
      className: "pill"
    }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(billableRate).toLocaleString("en-IN") || 0, "/h") : /*#__PURE__*/React.createElement("div", {
      className: "pill"
    }, /*#__PURE__*/React.createElement("span", {
      className: "budget-na-text"
    }, " NA "))), /*#__PURE__*/React.createElement("td", null, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(totalCost).toLocaleString("en-IN") || 0));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-details-task-management-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 3
  }, tasksOptionsData !== null && tasksOptionsData !== void 0 && (_tasksOptionsData$get9 = tasksOptionsData.gettaskWiseUserListingModal) !== null && _tasksOptionsData$get9 !== void 0 && _tasksOptionsData$get9.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get10 = tasksOptionsData.gettaskWiseUserListingModal) === null || _tasksOptionsData$get10 === void 0 ? void 0 : _tasksOptionsData$get10.length) < EMPLOYEE_LIMIT || isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll(e);
    }
  }, "Load more"))) : null))))))));
};